<div
  *ngIf="(notificationToDisplay$ | async) && !mobileService.isMobile"
  (click)="navigateTo()"
  class="notification-container"
  [matTooltip]="'profile.popout.anomalyText' | translate"
>
  <icon-component
    [cssClass]="['severity-indicator', 'severity-indicator-' + severity]"
    [iconName]="'record-filled'"
  ></icon-component>
  <span class="text-notification" [innerHtml]="notificationContent"> </span>
</div>
<div *ngIf="fakeMode$ | async" class="banner-container">
  <icon-component
    [iconName]="'icon-warning'"
    [toolTipText]="'Aktuell befindest du dich in der Sicht als anderer Agent'"
    [cssClass]="'fake-mode-icon'"
  ></icon-component>
</div>
<profile-fly-out-menu></profile-fly-out-menu>
